<template>
        <div class="account-page-padding">
            <h1>Payment Methods</h1>
            <div class="payment-method-grid">
                <PaymentMethodCardNew id="new_payment_method" @saveCard="reloadCreditCards" :regions="props.regions" :countries="props.countries" :user="props.user" ref="newPaymentMethod" />
                <PaymentMethodCard 
                    v-for="(card, index) in creditCards" 
                    :key="card.credit_card_id" 
                    :id="`payment_method_card_${card.credit_card_id}`" 
                    @deleteCreditCard="deleteCreditCard" 
                    @setDefault="setNewDefault($event)"
                    v-model="creditCards[index]" 
                    :user="props.user"
                    :otherUsers="otherUsers"
                />
            </div>
        </div>
</template>
<script lang="ts" setup>
    import { toRef, ref, computed } from "vue";
    import { router } from '@inertiajs/vue3'
    import { usePaymentMethod } from "@/helpers/composables/paymentMethod"
    import Account from "@/Shared/Account.vue";
    import PaymentMethodCard from "@/components/PaymentMethodCard.vue";
    import PaymentMethodCardNew from "@/components/PaymentMethodCardNew.vue";

    const {
        deleteConsumerCreditCard,
        deleteCompanyCreditCard
    } = usePaymentMethod();

    let props = defineProps({
        paymentMethods: {
            type: Array<Object>,
            default(){
                return []
            }
        },
        user: {
            type: Object,
            default(){
                return {};
            }
        },
        regions: {
            type: Array<Object>,
            default: []
        },
        countries: {
            type: Array<Object>,
            default: []
        },
        users: {
            type: Array<Object>,
            default: []
        },
    });

    const creditCards = toRef(props.paymentMethods);

    let deleteCreditCard = (id) => {
        if(props.user.is_dealer){
            deleteCompanyCreditCard(id, {
                afterFetch: (ctx)=>{
                    reloadCreditCards();
                }
            })
        }else{
            deleteConsumerCreditCard(id, {
                afterFetch: (ctx)=>{
                    reloadCreditCards();
                }
            })
        }
    };

    let reloadCreditCards = () => {
        router.reload({ 
            only: ['paymentMethods'],
            onSuccess: (data) => {
                let newCreditCards = Array.isArray(data?.props?.paymentMethods) ? data.props.paymentMethods : [];
                creditCards.value.splice(0, creditCards.value.length, ...newCreditCards);
                creditCards.value = creditCards.value.sort((a,b)=>{
                    if (b.is_default !== a.is_default) {
                        return b.is_default - a.is_default;
                    }
                    return b.credit_card_id - a.credit_card_id;
                });
            }
        });
    }

    const setNewDefault = (id)=>{
        creditCards.value.forEach((card,i)=>{
            card.is_default = card.credit_card_id == id ? 1 : 0
        })
        creditCards.value = creditCards.value.sort((a,b)=>{
            if (b.is_default !== a.is_default) {
                return b.is_default - a.is_default;
            }
            return b.credit_card_id - a.credit_card_id;
        });
    }

    let newPaymentMethod = ref(null);

    const otherUsers = computed(()=>{
        return props?.users?.filter((user)=>{
            return user.email != props.user.email;
        }) ?? [];
    })

</script>